import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Funnel } from "react-bootstrap-icons"; 

const PromotionFilter = ({ onFilter, cities = [], states = [], types = [] }) => {
  const [type, setType] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFilter = () => {
    onFilter({ type, city, state });
    handleClose();
  };

  const handleReset = () => {
    setType("");
    setCity("");
    setState("");
    onFilter({ type: "", city: "", state: "" });
    handleClose();
  };

  return (
    <>

      <Button
        variant="outline-dark"
        onClick={() => setShow(true)}
        title="Filter"
      >
        <Funnel className="me-1" />
        Filter
      </Button>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Filter Promotions</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-3" controlId="filterType">
            <Form.Label>Type</Form.Label>
            <Form.Select
              value={type}
              onChange={(e) => setType(e.target.value)}
              className="bg-white"
            >
              <option value="">All Types</option>
              {types.map((typeOption, idx) => (
                <option key={idx} value={typeOption}>
                  {typeOption}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3" controlId="filterCity">
            <Form.Label>City</Form.Label>
            <Form.Select
              value={city}
              onChange={(e) => setCity(e.target.value)}
              className="bg-white"
            >
              <option value="">All Cities</option>
              {cities.map((cityOption, idx) => (
                <option key={idx} value={cityOption}>
                  {cityOption}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3" controlId="filterState">
            <Form.Label>State</Form.Label>
            <Form.Select
              value={state}
              onChange={(e) => setState(e.target.value)}
              className="bg-white"
            >
              <option value="">All States</option>
              {states.map((stateOption, idx) => (
                <option key={idx} value={stateOption}>
                  {stateOption}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleReset}>
            Reset
          </Button>
          <Button variant="primary" onClick={handleFilter}>
            Apply
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PromotionFilter;
